import React from "react";

function PPTAddinCommands() {
    // VOID
    return <div></div>;
}

export default PPTAddinCommands;
